import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
import { useEffect, useState } from "react";

const DialogAlertNoInternetConnection = () => {
    const [showDialogNoInternetConnection, setShowDialogNoInternetConnection] = useState(null);
	useEffect(() => {
		window.addEventListener("offline", () => {
			setShowDialogNoInternetConnection(true);
		});
	}, []);
	useEffect(() => {
		if (showDialogNoInternetConnection !== false)
			return;
		setShowDialogNoInternetConnection(false);
		setTimeout(() => {
			window.location.reload();
		}, 620);
	}, [showDialogNoInternetConnection]);
	const toggleShowDialogNoInternetConnection = (value = null) => {
		setShowDialogNoInternetConnection(
			value !== null 
			? value
			: !showDialogNoInternetConnection);
	}
    return (
        <DialogAlertErrorNotify 
            type={2}
            show={showDialogNoInternetConnection === null 
                ? false : showDialogNoInternetConnection} 
            toggleShow={toggleShowDialogNoInternetConnection}/>
    );
}

export default DialogAlertNoInternetConnection;